import { render, staticRenderFns } from "./SubusersSettings.vue?vue&type=template&id=dbc5585c"
import script from "./SubusersSettings.vue?vue&type=script&lang=js"
export * from "./SubusersSettings.vue?vue&type=script&lang=js"
import style0 from "./SubusersSettings.vue?vue&type=style&index=0&id=dbc5585c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports